import {
  HStack,
  Text,
  Flex,
  Heading,
  VStack,
  Image,
  InputLeftElement,
  Input,
  InputGroup,
  Box,
  Portal,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Avatar,
} from '@chakra-ui/react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { SearchIcon, HamburgerIcon, WarningTwoIcon } from '@chakra-ui/icons';
import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { auth } from '../config/firebase';
import { CurrentUserContext } from '../contexts/CurrentUserProvider';

type HeaderProps = {
  handleHamburgerToggle(): void;
};

function Header({ handleHamburgerToggle }: HeaderProps) {
  const [user, loading, error] = useAuthState(auth);
  const { currentUser } = useContext(CurrentUserContext);
  const navigate = useNavigate();

  return (
    <>
      <Flex flex={1} direction="row" bg="blue.400" justifyContent="space-between" p={6} width="100%">
        <HStack flex={1}>
          <HamburgerIcon boxSize={10} color="orange.400" mr={4} onClick={handleHamburgerToggle} />
          <Heading color="orange.400" onClick={() => navigate('/')}>
            donne
          </Heading>
          <Flex flex={1} justifyContent="center" alignItems="center">
            <Text display="flex" variant="header" fontSize="3xl">Admin Portal</Text>
          </Flex>
        </HStack>
      </Flex>
    </>
  );
}

export default Header;
